import ClientServer from "../protocol/ClientServer_pb";

window.ClientServer = ClientServer;

export function Socket(host) {
    const _self = this;

    _self.token = null;

    _self.sid = null;
    _self.key1 = null;
    _self.key2 = null;

    _self.userID = null;
    _self.hallID = null;
    _self.gameId = null;

    _self.socket = null;
    _self.connected = false;
    _self.authenticated = false;
    _self.subscribed = null;
    _self.host = host;

    _self.requestID = 0;
    _self.handlers = {};

    _self.onConnect = function () { };
    _self.onDisconnect = function () { };
    _self.onNotification = function () { }

    _self.onInvitationReceivedNotification = function () { }
    _self.onInvitationAcceptedNotification = function () { }
}

// safeExecute executes the given fn if it is a function.
function safeExecute(fn) {
    if (fn && typeof fn === "function") {
        fn.apply(this, [].slice.call(arguments, 1));
        return true;
    }
    return false;
}

Socket.prototype.connect = async function () {
    this.socket = new WebSocket(this.host);
    this.socket.binaryType = 'arraybuffer';

    return new Promise((resolve, reject) => {
        this.socket.onopen = () => {
            this.connected = true;
            console.log(`Game server connection established: ${this.host}`);
            safeExecute(this.onConnect);
            resolve();
        };

        this.socket.onerror = event => {
            console.error(`Game server connection error: ${this.host}`);
            reject(event);
        };

        this.socket.onclose = event => {
            if (this.connected) {
                this.connected = false;
                this.subscribed = null;
                this.authenticated = false;
                console.log(`Game server connection closed: ${this.host}`);
                safeExecute(this.onDisconnect, event);
            }
        };

        this.socket.onmessage = event => {
            const message = event.data;
            const bytes = message.slice(4);
            const response = ClientServer.Response.deserializeBinary(bytes);
            const id = response.getRequestId();

            console.log(`%c Socket: received id: ${id} `, 'color: #f210dc');

            if (id === -1) {
                const notification = response.getNotification();
                let handled = false;
                if (notification.hasUserDisconnectNotification()) {
                    const disconnectNotification = notification.getUserDisconnectNotification();
                    if (disconnectNotification.getReason() == ClientServer.UserDisconnectNotification.Reason.PANIC) {
                        const url = window.location.protocol + "//" + (disconnectNotification.getVar2() || "https://google.com").replace(/^https?\:\/\//i, "");
                        if (window.frameElement || window == window.parent) {
                            window.location = url;
                        }
                        parent.postMessage({ msg: 'panic', url: url }, '*');
                    }
                    handled = true;
                }
                if (notification.hasPvpGamesRoomNotification()) {
                    const pvpGameNotification = notification.getPvpGamesRoomNotification();
                    if (pvpGameNotification.hasPvpGamesInvitationReceivedNotification()) {
                        this.onInvitationReceivedNotification(pvpGameNotification.getPvpGamesInvitationReceivedNotification());
                        handled = true;
                    } else if (pvpGameNotification.hasPvpGamesInvitationResponseNotification()) {
                        this.onInvitationAcceptedNotification(pvpGameNotification.getPvpGamesInvitationResponseNotification());
                        handled = true;
                    }
                }

                if (!handled) {
                    this.onNotification(notification);
                }
            } else if (id in this.handlers) {
                this.handlers[id](response);
                delete this.handlers[id];
            } else {
                console.warn(`Unknown request ID ${id} in the server response`);
            }
        };
    });
};

Socket.prototype.send = async function (request, operation) {
    const id = this.requestID++;
    request.setClientType(1);
    request.setRequestId(id);

    return new Promise((resolve, reject) => {
        this.handlers[id] = response => {
            const error = response.getError();
            if (error) {
                reject({
                    name: "ProtocolError",
                    operation: operation,
                    code: error.getCode(),
                    description: error.getDescription()
                });
            } else {
                resolve(response);
            }
        };

        const bytes = request.serializeBinary();
        const size = bytes.byteLength;
        const payload = new Uint8Array(size + 4);

        payload[0] = (size >> 0) & 0xff;
        payload[1] = (size >> 8) & 0xff;
        payload[2] = (size >> 16) & 0xff;
        payload[3] = (size >> 24) & 0xff;
        payload.set(bytes, 4);

        console.log(`%c Socket: sent ${operation}, id: ${id} `, 'color: #13dd13');

        this.socket.send(payload.buffer);
    });
};

Socket.prototype.login = async function () {
    const request = new ClientServer.Request();
    request.setCommand(ClientServer.Request.MessageType.MSG_SESSION_LOGIN);
    const login = new ClientServer.SessionLoginRequest();
    login.setToken(this.token);
    request.setSessionLoginRequest(login);

    const response = await this.send(request, "login");
    this.authenticated = true;
    this.userID = response.getSessionLoginResponse().getUid();
    this.userName = response.getSessionLoginResponse().getName();
    this.hallID = response.getSessionLoginResponse().getHallId();
    console.log("Authenticated");
    return response.getSessionLoginResponse();
};

Socket.prototype.loginSid = async function () {
    const request = new ClientServer.Request();
    request.setCommand(ClientServer.Request.MessageType.MSG_SESSION_LOGIN_2);
    const login = new ClientServer.SessionLoginRequest2();
    login.setSid(this.sid);
    login.setKey1(this.key1);
    login.setKey2(this.key2);
    request.setSessionLoginRequest2(login);

    const response = await this.send(request, "login");
    this.authenticated = true;
    this.userID = response.getSessionLoginResponse().getUid();
    this.userName = response.getSessionLoginResponse().getName();
    this.hallID = response.getSessionLoginResponse().getHallId();
    console.log("Authenticated");
    return response.getSessionLoginResponse();
};

Socket.prototype.getBalance = async function () {
    const request = new ClientServer.Request();
    request.setCommand(ClientServer.Request.MessageType.MSG_GET_PLAYER_BALANCE);
    request.setPlayerBalanceRequest(new ClientServer.PlayerBalanceRequest());

    const response = await this.send(request, "getBalance");
    console.log("Balance updated");
    return response.getPlayerBalanceResponse();
};

Socket.prototype.ping = async function () {
    const request = new ClientServer.Request();
    request.setCommand(ClientServer.Request.MessageType.MSG_PING);
    request.setPingRequest(new ClientServer.PingRequest());

    const response = await this.send(request, "ping");

    return response.getPingResponse();
};

Socket.prototype.gameSubscribe = async function (gameId) {
    if (this.subscribed) {
        return this.subscribed;
    }
    const request = new ClientServer.Request();
    request.setCommand(ClientServer.Request.MessageType.MSG_GAME_SUBSCRIBE);
    const subscribe = new ClientServer.GameSubscribeRequest();
    subscribe.setGameId(gameId);
    request.setGameSubscribeRequest(subscribe);
    const response = await this.send(request, "gameSubscribe");
    console.log("Subscribed");
    this.gameId = gameId;
    this.subscribed = response.getGameSubscribeResponse();

    return response.getGameSubscribeResponse();
};

Socket.prototype.pvpGamesListUsers = async function (limit, roomId) {
    const request = new ClientServer.Request();
    request.setCommand(ClientServer.Request.MessageType.MSG_GAME_COMMAND);

    const outer = new ClientServer.GameCommandRequest();
    outer.setGameId(this.gameId);

    const inner = new ClientServer.PvpGamesListUsersRequest();
    inner.setLimit(limit);
    inner.setRoomId(roomId);
    outer.setPvpGamesListUsersRequest(inner);

    request.setGameCommandRequest(outer);

    const response = await this.send(request, "pvpGamesListUsers");
    return response.getGameCommandResponse().getPvpGamesListUsersResponse();
};

Socket.prototype.pvpGamesInviteOpponent = async function (userId, gameId, roomId) {
    const request = new ClientServer.Request();
    request.setCommand(ClientServer.Request.MessageType.MSG_GAME_COMMAND);

    const outer = new ClientServer.GameCommandRequest();
    outer.setGameId(this.gameId);

    const inner = new ClientServer.PvpGamesInviteOpponentRequest();
    inner.setUserId(userId);
    inner.setGameId(gameId);
    inner.setRoomId(roomId);
    outer.setPvpGamesInviteOpponentRequest(inner);

    request.setGameCommandRequest(outer);

    const response = await this.send(request, "pvpGamesInviteOpponentRequest");
    return response.getGameCommandResponse().getPvpGamesInviteOpponentResponse();
};

Socket.prototype.pvpGamesAcceptInvitation = async function (hash, accept) {
    const request = new ClientServer.Request();
    request.setCommand(ClientServer.Request.MessageType.MSG_GAME_COMMAND);

    const outer = new ClientServer.GameCommandRequest();
    outer.setGameId(this.gameId);

    const inner = new ClientServer.PvpGamesAcceptInvitationRequest();
    inner.setHash(hash);
    inner.setAccept(accept);
    outer.setPvpGamesAcceptInvitationRequest(inner);

    request.setGameCommandRequest(outer);

    const response = await this.send(request, "pvpGamesAcceptInvitationRequest");
    return response.getGameCommandResponse().getPvpGamesAcceptInvitationResponse();
};

Socket.prototype.pvpGamesListRooms = async function () {
    const request = new ClientServer.Request();
    request.setCommand(ClientServer.Request.MessageType.MSG_GAME_COMMAND);

    const outer = new ClientServer.GameCommandRequest();
    outer.setGameId(this.gameId);

    const inner = new ClientServer.PvpGamesListRoomsRequest();
    outer.setPvpGamesListRoomsRequest(inner);

    request.setGameCommandRequest(outer);

    const response = await this.send(request, "pvpGamesListRooms");
    return response.getGameCommandResponse().getPvpGamesListRoomsResponse();
};

Socket.prototype.pvpGamesWatchRoom = async function (roomId) {
    const request = new ClientServer.Request();
    request.setCommand(ClientServer.Request.MessageType.MSG_GAME_COMMAND);

    const outer = new ClientServer.GameCommandRequest();
    outer.setGameId(this.gameId);

    const inner = new ClientServer.PvpGamesWatchRoomRequest();
    inner.setRoomId(roomId);

    outer.setPvpGamesWatchRoomRequest(inner);
    request.setGameCommandRequest(outer);

    const response = await this.send(request, "pvpGamesWatchRoom");
    return response.getGameCommandResponse().getPvpGamesWatchRoomResponse();
};

Socket.prototype.pvpGamesExitRoom = async function () {
    const request = new ClientServer.Request();
    request.setCommand(ClientServer.Request.MessageType.MSG_GAME_COMMAND);

    const outer = new ClientServer.GameCommandRequest();
    outer.setGameId(this.gameId);

    const inner = new ClientServer.PvpGamesExitRoomRequest();

    outer.setPvpGamesExitRoomRequest(inner);
    request.setGameCommandRequest(outer);

    const response = await this.send(request, "pvpGamesExitRoom");
    return response.getGameCommandResponse().getPvpGamesExitRoomResponse();
};

Socket.prototype.pvpGamesPlayRoom = async function (roomId, aiLevel, tournamentId) {
    const request = new ClientServer.Request();
    request.setCommand(ClientServer.Request.MessageType.MSG_GAME_COMMAND);

    const outer = new ClientServer.GameCommandRequest();
    outer.setGameId(this.gameId);

    const inner = new ClientServer.PvpGamesPlayRoomRequest();
    inner.setRoomId(roomId);
    inner.setAiLevel(aiLevel);
    inner.setTournamentId(tournamentId);

    outer.setPvpGamesPlayRoomRequest(inner);
    request.setGameCommandRequest(outer);

    const response = await this.send(request, "pvpGamesPlayRoom");
    return response.getGameCommandResponse().getPvpGamesPlayRoomResponse();
};

Socket.prototype.pvpGamesSendbet = async function (betType) {
    const request = new ClientServer.Request();
    request.setCommand(ClientServer.Request.MessageType.MSG_GAME_COMMAND);

    const outer = new ClientServer.GameCommandRequest();
    outer.setGameId(this.gameId);

    const inner = new ClientServer.PvpGamesPokerBetRequest();
    inner.setBetType(betType);

    outer.setPvpGamesPokerBetRequest(inner);
    request.setGameCommandRequest(outer);

    const response = await this.send(request, "pvpGamesSendbet");
    return response.getGameCommandResponse().getPvpGamesPokerBetResponse();
};

Socket.prototype.pvpGamesBackgammonRoll = async function ({ choices }) {
    const request = new ClientServer.Request();
    request.setCommand(ClientServer.Request.MessageType.MSG_GAME_COMMAND);

    const outer = new ClientServer.GameCommandRequest();
    outer.setGameId(this.gameId);

    const inner = new ClientServer.PvpGamesBackgammonRollRequest();
    inner.setChoicesList(choices);

    outer.setPvpGamesBackgammonRollRequest(inner);
    request.setGameCommandRequest(outer);

    const response = await this.send(request, "pvpGamesBackgammonRoll");
    return response.getGameCommandResponse().getPvpGamesBackgammonRollResponse();
};

Socket.prototype.pvpGamesBackgammonMove = async function ({ from, to }) {
    const request = new ClientServer.Request();
    request.setCommand(ClientServer.Request.MessageType.MSG_GAME_COMMAND);

    const outer = new ClientServer.GameCommandRequest();
    outer.setGameId(this.gameId);

    const inner = new ClientServer.PvpGamesBackgammonMoveRequest();
    inner.setFrom(from);
    inner.setTo(to);

    outer.setPvpGamesBackgammonMoveRequest(inner);
    request.setGameCommandRequest(outer);

    const response = await this.send(request, "pvpGamesBackgammonMove");
    return response.getGameCommandResponse().getPvpGamesBackgammonMoveResponse();
};

Socket.prototype.pvpGamesBackgammonDoublingCube = async function (action) {
    const request = new ClientServer.Request();
    request.setCommand(ClientServer.Request.MessageType.MSG_GAME_COMMAND);

    const outer = new ClientServer.GameCommandRequest();
    outer.setGameId(this.gameId);

    const inner = new ClientServer.PvpGamesBackgammonDoublingCubeRequest();
    inner.setAction(action);

    outer.setPvpGamesBackgammonDoublingCubeRequest(inner);
    request.setGameCommandRequest(outer);

    const response = await this.send(request, "pvpGamesBackgammonDoublingCubeResponse");
    return response.getGameCommandResponse().getPvpGamesBackgammonDoublingCubeResponse();
};

Socket.prototype.pvpGamesListTournaments = async function () {
    const request = new ClientServer.Request();
    request.setCommand(ClientServer.Request.MessageType.MSG_GAME_COMMAND);

    const outer = new ClientServer.GameCommandRequest();
    outer.setGameId(this.gameId);

    const inner = new ClientServer.PvpGamesListTournamentsRequest();
    outer.setPvpGamesListTournamentsRequest(inner);

    request.setGameCommandRequest(outer);

    const response = await this.send(request, "pvpGamesListTournaments");
    return response.getGameCommandResponse().getPvpGamesListTournamentsResponse();
};

Socket.prototype.setPlayerPrefsRequest = async function (prefs) {
    const request = new ClientServer.Request();
    request.setCommand(ClientServer.Request.MessageType.MSG_SET_PLAYER_PREFS);
    const inner = new ClientServer.SetPlayerPrefsRequest();
    inner.setAvatar(prefs.avatar);
    request.setSetPlayerPrefsRequest(inner);

    const response = await this.send(request, "setPlayerPrefsRequest");
    return response.getSetPlayerPrefsResponse();
};
